import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { FormControl, FormHelperText } from "@mui/material";
import { getPointerEventsStyles, getReadOnlyStyles } from "../../lib/styles";
import { DATE_TIME_FORMAT, DATE_FORMAT } from "../../lib/constants";
import { format, parse } from "date-fns";

export const DateInput = ({ fieldConfig, controllerField, fieldState }) => {
  const { type, readOnly } = fieldConfig;
  const { value, onChange, ...rest } = controllerField;

  const PickerComponent = type === "dateTime" ? DateTimePicker : DatePicker;
  const formatString = type === "dateTime" ? DATE_TIME_FORMAT : DATE_FORMAT;

  const parsedValue =
    type === "date" && typeof value === "string" && value.length === 10
      ? parse(value, "yyyy-MM-dd", new Date())
      : value
      ? new Date(value)
      : null;

  const handleDateChange = (date) => {
    if (!date) {
      onChange(null);
    } else if (type === "date") {
      onChange(format(date, "yyyy-MM-dd"));
    } else {
      onChange(date.toISOString());
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl
        fullWidth
        error={!!fieldState.error}
        sx={getReadOnlyStyles(readOnly)}
      >
        <PickerComponent
          {...rest}
          disabled={readOnly}
          value={parsedValue}
          onChange={handleDateChange}
          slotProps={{
            textField: {
              variant: "outlined",
              size: "small",
              sx: getPointerEventsStyles(readOnly),
              inputProps: {
                placeholder: formatString,
                readOnly: true,
              },
            },
          }}
        />
        {!!fieldState.error && (
          <FormHelperText>{fieldState.error.message}</FormHelperText>
        )}
      </FormControl>
    </LocalizationProvider>
  );
};
